import { HttpService } from '@/utils/http/index'
const $http = new HttpService()

/**
 * 获取主题列表
 */
export const getThemeListApi = () => $http.get('/scene/scene_list')

/**
 * 保存主题列表
 */
export const saveThemeListApi = (data: object) => $http.post('/scene/scene_save', data)

/**
 * 根据主题ID获取场景列表
 */
export const getSceneListApi = (scene_id: string) => $http.get('/scene/scene_item_list', { scene_id })

/**
 * 保存场景信息
 */
export const saveSceneApi = (data: object) => $http.post('/scene/scene_item_save', data)

/**
 * 删除场景信息
 */
export const delSceneApi = (scene_item_id: number) => $http.post('/scene/scene_item_del', { scene_item_id })


/************************************************************ 生日贺卡 - begin ******************************************************************/
/**
 * 获取贺卡配置列表
 */
export const getCardListApi = (params: object) => $http.get('/dsapi/greet/list', params)

/**
 * 保存贺卡模板
 */
export const saveCardApi = (data: object) => $http.post('/dsapi/greet/add', data)

/**
 * 删除贺卡信息
 */
export const delCardApi = (id: number) => $http.post('/dsapi/greet/del', { id })
/************************************************************ 生日贺卡 - end ******************************************************************/


/************************************************************ 礼品卡管理 - begin ******************************************************************/
/**
 * 获取礼品卡列表
 */
export const getGiftCardListApi = () => $http.get('/cake_api/cardStyleList')

/**
 * 删除礼品卡信息
 */
export const delGiftCardApi = (ids: number) => $http.post('/cake_api/deleteCardStyle', { ids })

/**
 * 保存礼品卡信息
 */
export const saveGiftCardApi = (data: object) => $http.post('/cake_api/cardStyles', {card_styles: data})

/**
 * 修改礼品卡信息
 */
export const updateGiftCardApi = (data: object) => $http.post('/cake_api/updateCardStyle', data)
/************************************************************ 礼品卡管理 - end ******************************************************************/


/**
 * 获取生日管家配置图片列表
 */
export const getBirthdayImgListApi = () => $http.get('/cake_api/birthday_img_list', { skip: 1 })

/**
 * 保存生日管家配置图片
 */
export const saveBirthdayImgApi = (params: object) => $http.post('/cake_api/birthday_img', params)

/**
 * 图片资源列表
 */
export const getImgListApi = (params: object) => $http.get('/admin/user/get_img_list', params)

/**
 * 保存图片信息
 */
export const uploadImgApi = (data: object) => $http.post('/admin/user/do_up_img', data)


/************************************************************ 专题管理 - begin ******************************************************************/
/**
 * 获取专题列表
 */
export const getTopicListApi = (params: object) => $http.get('/opsapi/topicList', params)
/**
 * 保存专题信息
 */
export const saveTopicInfoApi = (data: object) => $http.post('/opsapi/topicSave', data)
/**
 * 保存专题配置
 */
export const saveTopicConfigApi = (data: object) => $http.post('/opsapi/saveTenTopic', data)
/**
 * 获取专题配置
 */
export const getTopicConfigApi = (id: any) => $http.post('/opsapi/getTenTopicDetail', { id })
/**
 * 克隆专题
 */
export const cloneTopicApi = (id: any) => $http.post('/opsapi/cloneTopic', { id })
/************************************************************ 专题管理 - end ******************************************************************/
